import { useSelector } from 'react-redux';
import { useNavigate, useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from "./Hooks/useAuth";

const PrivateRoute = ({ children, allowedRoles }) => {


  const { auth } = useAuth();
  const location = useLocation();

  return (
    
    allowedRoles.includes(auth?.User?.usertype)? <Outlet />
      : auth.User ?
        <Navigate to="/MyHussain/Unauthorized404" state={{ from: location }} replace />
        :
        <Navigate to="/MyHussain/login" state={{ from: location }} replace />
  );
};




export default PrivateRoute;